/**
 * THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY
 * To add new icons to the system, or to update existing icons, run `clyde mana assets sync -t icons`.
 */

import * as React from 'react';
import tokens from '@discordapp/tokens/web';

import addDefaultIconProps from '../addDefaultIconProps';
import {getIconSize} from '../getIconSize';

import type {TwoColorIconProps} from '../IconTypes';

/**
 * ![CircleXIcon](data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAAB2UlEQVR4nMVVTS8EQRCduOCGI+JOgkRC3EhcZk13VYv0VIXD+vgPIsRP8vE3EBxxRWS5IBwJqWFN70zP7lgJnVTSmcm8V/Wq6k0Q/Oex1vaB4TVAPtCGL8DQi8TXfR8gXo2ipd52gLvB0DYYegLD781CIz9qpC35phQ4APcD8lErYMgSGTpTyg41BV9YWB4Ewzc/BYfvaug6iuxAsSzIJ+2CQ1rJ8Uy12pUj0Eg7vwWH76DNbPZ9voaqZEoWZzXSXQ4E+V7reFopO+NrfMN0JaPoyUQhzQVB0FGp2FEwVHPBoygel3dKxZMF/VhJCZAPvKViClQnkWpCvThWf+at7rMXe47+fFmoJ/K9CyjhrSpHwBcuwXPTpmFKIhGCHdFIty0W8Lk0gXZkkZifN8OtCGRoyklkqObKUr8LoVRWSqLEuAoyrziAnw1NCWUACkmQdx3/iVc94G9KxRN+oJRERrmggmrDoslyZJr0KlpHkZ3yZSnVfC3humdEHxCrPVmr2CpvBdzcj5A3cl4kBiVG9XtwOvSanRyxWrHctsENX8n/xAueNpz7JYufg9Npyx+OK5dYbrbxBcAPonkYhp2lwBslW+oVV0z2BOlcNj7Zerkb2pNRzE3LX58PiqXIHAQFlGwAAAAASUVORK5CYII=)
 */
export const CircleXIcon = ({
  size = 'md',
  width,
  height,
  secondaryColor = 'transparent',
  secondaryColorClass = '',
  color = tokens.colors.INTERACTIVE_NORMAL,
  colorClass = '',
  ...props
}: TwoColorIconProps) => {
  const iconSize = getIconSize(size);
  const iconWidth = iconSize?.width ?? width;
  const iconHeight = iconSize?.height ?? height;
  return (
    <svg
      {...addDefaultIconProps(props)}
      xmlns="http://www.w3.org/2000/svg"
      width={iconWidth}
      height={iconHeight}
      fill="none"
      viewBox="0 0 24 24">
      <circle
        cx="12"
        cy="12"
        r="10"
        fill={typeof secondaryColor === 'string' ? secondaryColor : secondaryColor.css}
        className={secondaryColorClass}
      />
      <path
        fill={typeof color === 'string' ? color : color.css}
        fillRule="evenodd"
        d="M12 23a11 11 0 1 0 0-22 11 11 0 0 0 0 22Zm4.7-15.7a1 1 0 0 0-1.4 0L12 10.58l-3.3-3.3a1 1 0 0 0-1.4 1.42L10.58 12l-3.3 3.3a1 1 0 1 0 1.42 1.4L12 13.42l3.3 3.3a1 1 0 0 0 1.4-1.42L13.42 12l3.3-3.3a1 1 0 0 0 0-1.4Z"
        clipRule="evenodd"
        className={colorClass}
      />
    </svg>
  );
};
